import moment from "moment";

// Helper function to determine if the current meeting is the next meeting in
// the meeting group, based on the previous meeting's start datetime and
// the current meeting's start datetime.
export const isNextMeetingInGroup = (meeting: {
  previousMeeting?: { startDatetime: string | null | undefined };
  startDatetime: string | null | undefined;
}) => {
  const previousMeetingIsCompleted = moment().isAfter(
    moment(meeting.previousMeeting?.startDatetime),
    "minute",
  );
  const meetingIsTooFarInThePast = moment(meeting.startDatetime).isBefore(
    moment().subtract(90, "day"),
    "day",
  );
  if (
    meetingIsTooFarInThePast ||
    !meeting.previousMeeting ||
    !previousMeetingIsCompleted
  ) {
    return false;
  }
  return true;
};
